var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.038,
    height: 14.038,
    viewBox: "0 0 14.038 14.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M0,14.038V1.4A1.406,1.406,0,0,1,1.4,0H12.635a1.405,1.405,0,0,1,1.4,1.4V9.827a1.405,1.405,0,0,1-1.4,1.4H2.808L0,14.036ZM6.5,8a.5.5,0,1,0,0,1h1A.5.5,0,0,0,8,8.5.5.5,0,0,0,7.5,8ZM7,2A1,1,0,0,0,6,3V6A1,1,0,1,0,8,6V3A1,1,0,0,0,7,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.2dfd9743f43c7ae6088b7f72ded314bf.svg";
export { ForwardRef as ReactComponent };